import Vue from 'vue';
import Router from 'vue-router';

// Framework
import {
    Home,
    Help,
    BriefInfo,
    BriefReward,
    Upload,
    Thanks,
    Profile,
    ProfileAbout,
    ProfileVideos,
    ProfileEditGeneral,
    ProfileEditSocial,
    ProfileEditAddress,
    ProfilePrivacy,
    Project,
} from '@skeepers/platform-framework/views/mobile';
import {
    NotFound,
    Forbidden,
} from '@skeepers/platform-framework/views/shared';
import {
    routerStrategy,
} from '@skeepers/platform-framework/data';

// Casting
import {
    BriefWrapper,
    BriefSteps,
    Typeform,
    Deposit,
} from '@/views/mobile';
import {
    PostponeModal,
    CompleteModal,
} from '@/views/shared';

export default new Router({
    mode: 'history',
    base: routerStrategy('base') || '/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: { tracking: 'CASTING_HOMEPAGE_VIEW' },
        }, {
            path: '/brief',
            name: 'brief',
            redirect: '/brief/info',
            component: BriefWrapper,
            meta: { auth: true, tracking: 'CASTING_BRIEF_VIEW' },
            children: [
                {
                    path: '/brief/info',
                    name: 'brief.info',
                    component: BriefInfo,
                    props: { next: 'brief.steps', pictureCover: true },
                }, {
                    path: '/brief/steps',
                    name: 'brief.steps',
                    component: BriefSteps,
                    props: { next: 'brief.reward' },
                }, {
                    path: '/brief/reward',
                    name: 'brief.reward',
                    component: BriefReward,
                    props: { next: 'typeform', pictureCover: true },
                },
            ],
        }, {
            path: '/typeform',
            name: 'typeform',
            component: Typeform,
            meta: { auth: true, tracking: 'CASTING_TYPEFORM_START' },
        }, {
            path: '/deposit',
            name: 'deposit',
            component: Deposit,
            props: { next: 'upload' },
            meta: { auth: true },
            children: [
                {
                    path: '/deposit/postpone',
                    name: 'deposit.postpone',
                    component: PostponeModal,
                    props: { parent: 'deposit' },
                }, {
                    path: '/deposit/complete',
                    name: 'deposit.complete',
                    component: CompleteModal,
                    props: { parent: 'deposit' },
                },
            ],
        }, {
            path: '/upload',
            name: 'upload',
            component: Upload,
            props: { next: 'thanks' },
            meta: { auth: true, tracking: 'CASTING_UPLOAD_VIEW' },
        }, {
            path: '/thanks',
            name: 'thanks',
            component: Thanks,
            meta: { auth: true, tracking: 'CASTING_THANKS_VIEW' },
        }, {
            path: '/profile',
            name: 'profile',
            redirect: '/profile/about',
            component: Profile,
            meta: { auth: true },
            children: [
                {
                    path: '/profile/about',
                    name: 'profile.about',
                    component: ProfileAbout,
                }, {
                    path: '/profile/videos',
                    name: 'profile.videos',
                    component: ProfileVideos,
                },
            ],
        }, {
            path: '/profile/edit/general',
            name: 'profile.edit.general',
            component: ProfileEditGeneral,
            meta: { auth: true },
        }, {
            path: '/profile/edit/social',
            name: 'profile.edit.social',
            component: ProfileEditSocial,
            meta: { auth: true },
        }, {
            path: '/profile/edit/address',
            name: 'profile.edit.address',
            component: ProfileEditAddress,
            props: (route) => ({
                ...route.params,
            }),
            meta: { auth: true },
        }, {
            path: '/profile/privacy',
            name: 'profile.privacy',
            component: ProfilePrivacy,
            meta: { auth: true },
        }, {
            path: '/project/:projectID',
            name: 'project',
            component: Project,
            props: true,
            meta: { auth: true },
        }, {
            path: '/help',
            name: 'help',
            component: Help,
            meta: { auth: true },
        }, {
            path: '/forbidden',
            name: 'forbidden',
            component: Forbidden,
        }, {
            path: '*',
            name: 'not-found',
            component: NotFound,
        },
    ],
});
